const phoneIsValid = (value) => {
  const strValue = value ? value.toString() : '';
  return strValue.length === 10;
};

export default phoneIsValid;
